import React, { useRef, useState } from "react";
import BaseWrapper from "../../../components/ui/BaseWrapper";
import BaseTextField from "../../../components/ui/BaseTextField";
import PhoneInput from "react-phone-input-2";
import { FormHelperText } from "@mui/material";
import BaseAutoSelect from "../../../components/ui/BaseAutoSelect";
import { useQuery } from "@tanstack/react-query";
import { fetchAllClients } from "../../../services/api/client";
import { debounce } from "lodash";

const CreateEditClientAccountForm = ({ formik }) => {
  const [queryParams, setQueryParams] = useState("");
    const [searchInput, setSearchInput] = useState("");
  
  const { isPending: isClientsLoading, data: clientsData } = useQuery({
    queryKey: ["clients", queryParams],
    queryFn: () => fetchAllClients({ search: queryParams }),
  });

    const handleSearchChange = (_event, newInputValue) => {
    const inputValue = (newInputValue || "").trim();
    setSearchInput(inputValue);
    debouncedSearch(inputValue);
  };
  const debouncedSearch = useRef(
    debounce((query) => {
      setQueryParams(query);
    }, 500)
  ).current;

  const formattedClientData = clientsData?.data?.data?.map((client) => ({
    label: client.clientName,
    value: client.id,
  }));

  return (
    <BaseWrapper>
      <div className="pb-8">
        <form
          onSubmit={formik.handleSubmit}
          className="grid grid-cols-3 gap-y-5 mt-7 text-black"
        >
            <div className="lg:mr-10 lg:col-span-1 col-span-2">
            <BaseAutoSelect
              fullHeight={false}
              fullWidth
              labelShrink={false}
              id="clientId"
              name="clientId"
              label="Client Name"
              options={formattedClientData}
              required={true}
              value={formik?.values?.clientId}
              onChange={formik?.handleChange}
              onInputChange={handleSearchChange}
              onBlur={formik.handleBlur}
              error={formik.touched.clientId && formik.errors.clientId}
              helperText={formik.touched.clientId && formik.errors.clientId}
            />
          </div>
          <div className="lg:mr-10 lg:col-span-1 col-span-2">
            <BaseTextField
              fullHeight={false}
              fullWidth
              labelShrink={false}
              id="accountsPerson"
              name="accountsPerson"
              label="Accounts Person"
              optional={false}
              value={formik.values?.accountsPerson}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.accountsPerson && formik.errors.accountsPerson}
              helperText={formik.touched.accountsPerson && formik.errors.accountsPerson}
            />
          </div>

          <div className="lg:mr-10 lg:col-span-1 col-span-2">
            <BaseTextField
              fullHeight={false}
              fullWidth
              labelShrink={false}
              id="email"
              name="email"
              label="Email"
              optional={false}
              value={formik.values?.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && formik.errors.email}
              helperText={formik.touched.email && formik.errors.email}
            />
          </div>

          <div className="lg:mr-10 lg:col-span-1 col-span-2">
            <label htmlFor="phone" className="block text-sm font-sm mb-1 text-[#505050]">
              Phone
            </label>
            <div className="relative w-full">
              <PhoneInput
                inputClass={`!w-full !h-[42px] !pl-12 !pr-3 !text-sm !font-light !text-black !bg-white !border !rounded-md !shadow-md ${formik.touched.phone && formik.errors.phone && "!border-gray-300"
                  } focus:!outline-none focus:!ring-1 focus:!ring-orange-400`}
                buttonClass="!border-none !bg-transparent"
                containerClass="!w-full"
                country={"au"}
                specialLabel=""
                value={formik.values.phone}
                onChange={(value) => formik.setFieldValue("phone", value)}
                onBlur={() => formik.setFieldTouched("phone", true)}
                inputProps={{
                  name: "phone",
                  id: "phone",
                  type: "tel",
                }}
              />
              {formik.touched.phone && formik.errors.phone && (
                <FormHelperText error>{formik.errors.phone}</FormHelperText>
              )}
            </div>
          </div>

          <div className="lg:mr-10 lg:col-span-1 col-span-2">
            <BaseTextField
              fullHeight={false}
              fullWidth
              labelShrink={false}
              id="paymentTerms"
              name="paymentTerms"
              label="Payment Terms"
              optional={false}
              value={formik.values?.paymentTerms}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.paymentTerms && formik.errors.paymentTerms}
              helperText={formik.touched.paymentTerms && formik.errors.paymentTerms}
            />
          </div>

          <div className="lg:mr-10 lg:col-span-1 col-span-2">
            <BaseAutoSelect
              labelShrink={false}
              label="Tax Type"
              required={true}
              fullWidth
              options={[
                {
                  label: "GST",
                  value: "GST",
                },
                {
                  label: "VAT",
                  value: "VAT",
                },
              ]}
              id="taxType"
              name="taxType"
              value={formik.values.taxType}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.taxType && Boolean(formik.errors.taxType)}
              helperText={formik.touched.taxType && formik.errors.taxType}
            />

          </div>

          <div className="lg:mr-10 lg:col-span-1 col-span-2">
            <BaseTextField
              fullHeight={false}
              fullWidth
              labelShrink={false}
              id="taxPercentage"
              name="taxPercentage"
              label="Tax Percentage"
              optional={false}
              value={formik.values?.taxPercentage}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 6 }}
              error={formik.touched.taxPercentage && formik.errors.taxPercentage}
              helperText={formik.touched.taxPercentage && formik.errors.taxPercentage}
            />
          </div>
        </form>
      </div>
    </BaseWrapper>
  );
};

export default CreateEditClientAccountForm;
